import { Component, OnInit, OnDestroy, ElementRef, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgbTabsetConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GlobalService } from 'src/app/app-core/lib/global.service';
import { LoginService } from 'src/app/app-core/services/login.service';
import { NotificationService } from 'src/app/app-core/services/notification.service';
import { CryptoService } from 'src/app/app-core/services/crypto.service';

import { INotification } from 'src/app/interfaces/notification';

import swal from 'sweetalert2';
import { IUser } from 'src/app/interfaces/user';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/app-core/services/user.service';
import { WebSocketService } from 'src/app/app-core/services/web-socket.service';
import { InternalProcessService } from 'src/app/app-core/services/internal-process.service';
import { internalProcessStatusEnum } from 'src/app/Enums/internalProcessEnum';
import { UserSessionService } from 'src/app/app-core/services/user-session.service';

interface PadProcess {
    PI_CodigoProcessoInterno: number;
    PI_NumeroProcessoInterno: string;
    PAD_Nome: string;
    PAD_PrazoCiencia: Date;
    PI_DataCriacao: Date;
    PIT_Status: number;
    visualizado: boolean;
}

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    providers: [LoginService, NotificationService, UserService, WebSocketService],
})
export class NavbarComponent implements OnInit, OnDestroy {
    constructor(
        public location: Location,
        public global: GlobalService,
        public login: LoginService,
        public element: ElementRef,
        public router: Router,
        public notificationService: NotificationService,
        private userService: UserService,
        public tabsetConfig: NgbTabsetConfig,
        private cryptoService: CryptoService,
        private webSocketService: WebSocketService,
        private internalProcessService: InternalProcessService,
        public modalService: NgbModal,
        private userSession: UserSessionService,
    ) {
        this.location = location;
        this.user = this.global.user();
        tabsetConfig.justify = 'center';
        tabsetConfig.type = 'tabs';
    }

    public listTitles: any[];
    public user: IUser;
    public notifications: any[] = [];
    public unreadNotifications: number;
    public readNotifications: number;
    public formattedGroupName: string = this.userService.formatGroupName();
    public padCount: number = 0;
    public padProcesses: PadProcess[] = [];
    public unviewedPadCount: number = 0;
    public selectedPad: PadProcess; 
    public newestUnviewedPad: PadProcess | null = null;
    public permissionPadProcesses: any[] = [];
    public padPopupShown = false;
    public isPermissionPad = false;
    public unviewedPermissionPadCount: number = 0;
    public openFaqIndex: number | null = null;
    // Cada resposta é uma lista de parágrafos: o espaçamento entre eles é
    // definido no SCSS, não por <br> dentro do texto.
    public faqList: { question: string; answer: string[] }[] = [
        {
            question: 'Como acesso a minha solicitação ou processo?',
            answer: [
                'Na tela inicial do Sistema de Protocolo Eletrônico, localize a solicitação desejada na lista e clique no botão “Ver”, na coluna Ações. Você também pode usar os Filtros para buscar por número de solicitação, NUP, assunto ou status.',
            ],
        },
        {
            question: 'A triagem devolveu minha solicitação para a correção, como prosseguir?',
            answer: [
                'Acesse a solicitação com status “Correção” e clique em “Ver”. Você será direcionado à Área de Correção de Solicitação, onde poderá revisar as informações apontadas pela triagem e reenviar os documentos necessários.',
                'Para anular um documento já enviado, clique no botão “X” ao lado dele na lista de anexos.',
            ],
        },
        {
            question: 'Como abro uma nova solicitação?',
            answer: [
                'Clique no botão “+ Nova Solicitação”, localizado no canto superior direito da tela inicial. Em seguida, selecione o órgão e o assunto desejados, descreva sua solicitação e concorde com o termo apresentado.',
                'Anexe toda a documentação obrigatória. Caso o requerimento seja digital, realize a assinatura utilizando sua conta Gov.br.',
                'Se o requerimento não for digital, acesse a seção Documentos e clique no botão “Baixar Formulário”. Após o download, preencha e assine o documento, anexe-o no campo Requerimento e, em seguida, adicione os demais documentos obrigatórios.',
                'Após conferir todas as informações e documentos anexados, clique em “Salvar Solicitação” para concluir o envio.',
            ],
        },
        {
            question: 'Em caso de representação, como prosseguir?',
            answer: [
                'Ao abrir uma nova solicitação, selecione a opção “Quero representar uma pessoa física ou jurídica” e informe os dados da pessoa que será representada. Em seguida, anexe o documento que comprove a autorização para a representação, como uma procuração ou documento equivalente.',
                'Para solicitações realizadas em nome de uma pessoa jurídica, é obrigatório utilizar a opção de representação.',
            ],
        },
        {
            question: 'Como acesso a área de notificações?',
            answer: [
                'Clique no ícone de sino, localizado no cabeçalho do sistema. O número em vermelho indica a quantidade de notificações não lidas. Ali você acompanha atualizações de status, prazos e mensagens sobre as suas solicitações.',
            ],
        },
        {
            question: 'Como realizo a correção do meu processo?',
            answer: [
                'Localize a solicitação com o status “Aguardando Ajuste do Cidadão” e clique no botão “Ver”. Em seguida, leia atentamente a pendência informada pelo responsável pela análise do processo.',
                'No campo Considerações (preenchimento obrigatório), informe as correções realizadas.',
                'Caso seja necessário substituir um documento, clique no botão “X” ao lado do arquivo correspondente e anexe o documento atualizado.',
                'Após realizar todas as correções solicitadas, clique em “Enviar Correção” para encaminhar novamente a solicitação para análise.',
            ],
        },
        {
            question: 'Em assuntos com o requerimento digital, como devo prosseguir?',
            answer: [
                'Caso o assunto selecionado possua um Requerimento Digital, será necessário assiná-lo digitalmente. Se o requerimento contiver campos editáveis, preencha todos os campos marcados com (*), que são de preenchimento obrigatório.',
                'Após concluir o preenchimento, leia e concorde com o Termo de Privacidade, posicione a assinatura no local desejado do documento e realize a assinatura utilizando sua conta Gov.br.',
            ],
        },
    ];

    private perfilAlteradoSub: Subscription;

    ngOnInit() {
        this.listenToNotifications();
        this.getNotifications();
        this.getPadProcesses();
        this.getPermissionPadProcesses();

        // O navbar fica fora do router-outlet e lê o usuário uma única vez, no construtor.
        // Sem isto, após a troca ele seguiria exibindo o nome do grupo anterior.
        //
        // Notificações, PADs e WebSocket não são recarregados de propósito: a troca de perfil
        // não muda a pessoa, e todos eles são consultados por usuário/CPF.
        this.perfilAlteradoSub = this.userSession.perfilAlterado$.subscribe(() => {
            this.user = this.global.user();
            this.formattedGroupName = this.userService.formatGroupName();
        });
    }

    ngOnDestroy() {
        this.perfilAlteradoSub?.unsubscribe();
    }

    logout() {
        if (this.global.govBr) {
            this.login.clearSessionFromLocalStorage();
            window.location.href = environment.govBR.logoutUrl;
        } else {
            this.login.logout();
        }
    }

    listenToNotifications() {
        const userId = this.global.user().USR_CodigoUsuario;

        let notificationQueue: INotification[] = [];
        let notificationTimeout: any;

        this.webSocketService.listen('new_notification').subscribe((data: INotification) => {
            if (data.NOT_Destinatario === userId) {
                notificationQueue.push(data);

                clearTimeout(notificationTimeout);
                notificationTimeout = setTimeout(() => {
                    notificationQueue.forEach(notification => {
                        this.notifications.push(this.formatNotification(notification));
                    });
                    this.playNotificationSound();
                    notificationQueue = [];
                }, 1000);
            }
        });
    }

    playNotificationSound() {
        const audio = new Audio('assets/sounds/notification.mp3');
        audio.play().catch((error) => {
            console.error('Erro ao reproduzir o som de notificação:', error);
        });
    }

    private updatePadNotification() {
        this.unviewedPadCount = this.padProcesses.filter(
            p => !p.visualizado
        ).length;


        this.unviewedPermissionPadCount =
            this.permissionPadProcesses.filter(
                p => !p.visualizado
            ).length;

        const unviewedPads = [...this.padProcesses]
            .filter(p => !p.visualizado)
            .sort((a, b) => {
                const dateA = new Date(a.PI_DataCriacao).getTime();
                const dateB = new Date(b.PI_DataCriacao).getTime();

                return dateB - dateA;
            });

        this.newestUnviewedPad =
            unviewedPads.length > 0
                ? unviewedPads[0]
                : null;
    }

    private formatNotification(notification: any): any {
        const numberMatch = notification.NOT_Link.match(/\d+/);

        if (numberMatch) {
            const number = numberMatch[0];
            const encryptedNumber = this.cryptoService.encrypt(number);
            notification.NOT_Link = notification.NOT_Link.replace(number, encryptedNumber);
        }

        if (notification.NOT_Status === 0) {
            this.unreadNotifications++;
        } else {
            this.readNotifications++;
        }

        return notification;
    }

    openHelpCenter(content: TemplateRef<any>) {
        this.openFaqIndex = null; // sempre abre com tudo recolhido
        this.modalService.open(content, {
            centered: true,
            size: 'md',
            windowClass: 'help-modal-window',
        });
    }

    toggleFaq(index: number) {
        this.openFaqIndex = this.openFaqIndex === index ? null : index;
    }

    getNotifications() {
        this.notificationService.listAll(`"NOT_Destinatario" = ${this.global.user().USR_CodigoUsuario} order by "NOT_DataNotificacao" desc`, 0).subscribe({
            next: (response: any) => {
                this.notifications = response.data;

                this.unreadNotifications = 0;
                this.readNotifications = 0;

                this.notifications = this.notifications.map(this.formatNotification.bind(this));
            },
        });
    }

    async handleClickNotification(notification: INotification) {
        if (notification.NOT_Status == 0) {
            await this.handleReadNotification(notification.NOT_CodigoNotificacao);
        }

        const dropdown = document.querySelector('#dropdown-notification');
        dropdown.classList.remove('show');
    }

    async handleReadNotification(notificationId: number) {
        await this.notificationService.save({ NOT_CodigoNotificacao: notificationId, NOT_Status: 1 }).subscribe({
            next: async () => {
                this.getNotifications()
                this.unreadNotifications = this.unreadNotifications - 1;
            },
        });
    }

    async markAllNotificationsAsRead(notifications: INotification[]) {
        const unreadNotifications = notifications.filter((notification) => notification.NOT_Status === 0);

        const unreadNotificationsIds = [];

        unreadNotifications.forEach((notification) => {
            unreadNotificationsIds.push(notification.NOT_CodigoNotificacao);
        });

        this.notificationService.markAllAsRead(unreadNotificationsIds).subscribe({
            next: async () => {
                swal.fire({
                    title: 'Notificações atualizadas',
                    text: 'Todas as notificações foram marcadas como lidas',
                    icon: 'success',
                    showCancelButton: true,
                    showConfirmButton: false,
                    cancelButtonText: 'OK',
                    cancelButtonColor: '#2563eb',
                });

                await this.getNotifications();
            },
        });
    }

    get isCitizen() {
        return this.userService.isCidadao();
    }

    get isCommissionMember() {
        return this.userService.isCommissionMember();
    }

    getPadProcesses() {
        const userCpf = this.global.user()?.PE_CPF;

        if (!userCpf) {
            console.warn('CPF do usuário não encontrado para buscar PADs');

            this.padProcesses = [];
            this.padCount = 0;

            this.updatePadNotification();

            return;
        }

        const formattedCpf = userCpf.replace(/\D/g, '');

        const condition =
            `"PI_Administrativo" = true ` +
            `AND "PIT_DataFim" IS NULL ` +
            `AND "PAD_CPF" LIKE '%${formattedCpf}%'`;

        this.internalProcessService.listAll(condition, 0).subscribe({
            next: (response: any) => {
                const viewedPads = this.getViewedPadsFromStorage();

                this.padProcesses = (response?.data || []).map((process: any) => ({
                    ...process,
                    visualizado: viewedPads.includes(
                        process.PI_CodigoProcessoInterno
                    )
                }));

                this.padCount = this.padProcesses.length;

                this.updatePadNotification();

                this.showNewPadModalIfNeeded();
            },

            error: (error) => {
                console.error('Erro ao obter lista de PADs:', error);

                this.padProcesses = [];
                this.padCount = 0;

                this.updatePadNotification();
            }
        });
    }

    markPadAsViewed(processId: number) {
        const viewedPads = this.getViewedPadsFromStorage();

        if (!viewedPads.includes(processId)) {
            viewedPads.push(processId);

            localStorage.setItem(
                'viewedPads',
                JSON.stringify(viewedPads)
            );
        }

        const process =
            this.padProcesses.find(
                p => p.PI_CodigoProcessoInterno === processId
            ) ??
            this.permissionPadProcesses.find(
                p => p.PI_CodigoProcessoInterno === processId
            );

        if (process) {
            process.visualizado = true;
        }

        this.updatePadNotification();
    }


    private getViewedPadsFromStorage(): number[] {
        try {
            const stored = localStorage.getItem('viewedPads');
            return stored ? JSON.parse(stored) : [];
        } catch (error) {
            console.error('Erro ao recuperar PADs visualizados:', error);
            return [];
        }
    }

    openPadModal(pad: PadProcess) {
        this.isPermissionPad = this.permissionPadProcesses.some(
            permissionPad =>
                permissionPad.PI_CodigoProcessoInterno ===
                pad.PI_CodigoProcessoInterno
        );

        const dropdownId = this.isPermissionPad
            ? '#dropdown-pad-permission'
            : '#dropdown-pad';

        const dropdown = document.querySelector(dropdownId);

        if (dropdown) {
            dropdown.classList.remove('show');
        }

        if (pad.visualizado) {
            this.navigateToPad(
                pad.PI_CodigoProcessoInterno
            );

            return;
        }

        this.markPadAsViewed(
            pad.PI_CodigoProcessoInterno
        );

        this.selectedPad = pad;

        this.global.showModalInfo('pad-modal');
    }

    async navigateToPad(processId: number) {
        this.global.closeModalInfo('pad-modal');

        this.markPadAsViewed(processId);

        const isPermissionPad =
            this.permissionPadProcesses.some(
                pad =>
                    pad.PI_CodigoProcessoInterno ===
                    processId
            );

        if (!isPermissionPad) {
            try {
                await this.updatePadStatusToDefense(processId);
            } catch (error) {
                console.error(
                    'Erro ao atualizar status do PAD:',
                    error
                );
            }
        }

        const encryptedId =
            this.cryptoService.encrypt(
                processId.toString()
            );

        this.router.navigate([
            '/internal-process/view/' + encryptedId
        ]);
    }

    private async updatePadStatusToDefense(processId: number): Promise<void> {
        await this.internalProcessService.updatePadStatus(processId, internalProcessStatusEnum.INTIMADO).toPromise();
    }

    navigateToAllPads() {
        const dropdown = document.querySelector('#dropdown-pad');
        if (dropdown) {
            dropdown.classList.remove('show');
        }
        
        this.router.navigate(['/admin-process/all']);
    }
    

    formatDate(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    }

    public getPermissionPadProcesses() {
        this.internalProcessService
            .listPermissionProcesses()
            .subscribe({
                next: (response: any) => {

                    const data =
                        Array.isArray(response)
                            ? response
                            : (response?.data || []);


                    const viewedPads =
                        this.getViewedPadsFromStorage();

                    this.permissionPadProcesses =
                        data.map((process: any) => ({
                            ...process,

                            visualizado:
                                viewedPads.includes(
                                    process.PI_CodigoProcessoInterno
                                )
                        }));

                    this.updatePadNotification();
                },

                error: (error) => {

                    console.error(
                        '[PAD PERMISSÃO] erro ao buscar processos:',
                        error
                    );

                    this.permissionPadProcesses = [];

                    this.unviewedPermissionPadCount = 0;

                    this.updatePadNotification();
                }
            });
    }

    public showNewPadModalIfNeeded(): void {
        const unviewedOwnPads = this.padProcesses
            .filter(pad => !pad.visualizado)
            .sort((a, b) => {
                const dateA = new Date(a.PI_DataCriacao).getTime();
                const dateB = new Date(b.PI_DataCriacao).getTime();

                return dateB - dateA;
            });

        const unviewedPermissionPads = this.permissionPadProcesses
            .filter(pad => !pad.visualizado)
            .sort((a, b) => {
                const dateA = new Date(a.PI_DataCriacao).getTime();
                const dateB = new Date(b.PI_DataCriacao).getTime();

                return dateB - dateA;
            });

        const newestPad =
            unviewedOwnPads[0] ||
            unviewedPermissionPads[0];

        if (!newestPad) {
            return;
        }

        const processId =
            newestPad.PI_CodigoProcessoInterno;

        const modalShownKey =
            `pad-modal-shown-${processId}`;

        if (sessionStorage.getItem(modalShownKey)) {
            return;
        }

        this.selectedPad = newestPad;

        this.isPermissionPad =
            this.permissionPadProcesses.some(
                pad =>
                    pad.PI_CodigoProcessoInterno ===
                    processId
            );

        sessionStorage.setItem(
            modalShownKey,
            'true'
        );

        setTimeout(() => {
            this.global.showModalInfo('pad-modal');
        }, 300);
    }

    get hasPadAccess(): boolean {
        return (
            this.isCitizen && this.padProcesses.length > 0
        );
    }

    get hasPermissionPadAccess(): boolean {
        return this.permissionPadProcesses.length > 0;
    }
}